import React from 'react';
import Footer from '../../Shared/Footer/Footer';
import Navigation from '../../Shared/Navigation/Navigation';

const CustomerService = () => {
    return (
        <>
        <Navigation></Navigation>
        <div style={{textAlign:'left',padding:"40px"}}>
            <h1>CUSTOMER SERVICE</h1>
            <h4>ORDERS</h4>
            <p>Once received, your order will be filled as quickly as possible. Please allow 1- 6 days for delivery of most goods within North America, and 2-4 weeks for overseas orders. We will notify you as soon as possible of any delays. If you require your order in a rush, please contact us via our CONTACT FORM to inquire about rush shipping. We will do our best to meet your deadline.</p>

            <h4>DISCOUNT CODES</h4>
            <p>Please link HERE.</p>

            <h4>CUSTOM ORDERS</h4>
            <p>We will accommodate custom changes to our designs whenever possible. Please send your inquiry via our CONTACT FORM. Additional charges may apply and all sales involving custom work are final.</p>

            <h4>PACKAGING</h4>
            <p>Each BIKO piece comes with it's own branded BIKO pouch. This pouch not only keeps your jewels safely stored - it serves as a polishing cloth as well as a travel pouch to keep your pieces in mint condition, wherever your journey may take you.  

            To be mindful of not over-packaging our goods, we only offer branded BIKO boxes upon request. All shipping boxes are recyclable.
</p>

<h4>PAYMENTS</h4>
<p>We accept all major credit cards (Visa, MasterCard, American Express), and you can choose to run your transaction through PayPal or through Shopify Payments. Both options are secure. You will receive a confirmation of your order via email with the total dollar amount (including any applicable taxes and shipping & handling).
All prices are listed and charged in Canadian dollars. If applicable, the exact exchange rate you will pay is determined by the bank that has issued your credit card.  In general, it will match very closely with the going exchange rate. Xe.com features a quick, easy, & free foreign exchange rate calculation using up-to-the-minute exchange rates.
</p>




<h4>TAXES</h4>
<p>Canadian customers will pay HST according to their provincial rate. American and international customers are responsible for all taxes and import duties levied by their respective countries.</p>

<h4>
RETURNS & REPAIRS</h4>
<p>All jewelry is created in our Toronto studio with love and care, and your satisfaction is very important to us. If for some reason you are not fully satisfied, please note the following instructions:
 
 Any purchases made online must be returned directly to BIKO Inc. and not to any retail stores. We are unable to accept any returns for items bought in a retail store.
 
 We will accept returns or exchanges on merchandise in its original unused condition, postmarked within 14 days of receiving shipment for refund or credit, less shipping costs. We do not accept returns after 14 days. All sales are final on customized and discounted items – this includes all items purchased with a discount code (excluding ‘Insider List’ welcome code).
 
 To return an item or to inquire about a repair, please email us here.</p>


<h4>LIFETIME WARRANTY</h4>
<p>Our pieces are designed to last a lifetime, and we stand by every product. We are glad to make reasonable repairs on your BIKO piece, for as long as you own it.
BIKO reserves the right to deny unreasonable repairs, returns, and exchanges.</p>


<h4>RETURNS & REPAIRS – SHIPPING</h4>
<p>To return merchandise please send all items to BIKO Inc. 174 Spadina Ave. Studio #411 Toronto, ON M5T 2C2 Canada. For your protection, please use a well-padded box or envelope (please no envelopes for earrings or rings!) and a traceable carrier. We cannot be responsible for items that are lost or damaged during return shipping. All costs related to return shipping are paid by the customer.</p>


<h4>ABOUT THE METALS</h4>
<p>Luxary Gold jewelry is made from brass, plated with 14k gold or rhodium. All earring posts are surgical stainless steel. Our metals are nickel-free and hypoallergenic and can be worn by most people, unless you have an extreme allergy and can only wear solid gold. (We call that an unfortunate 'expensive allergy'.) ;)

For increased longevity, keep jewelry clean and dry using a soft cloth. Avoid wearing your jewelry in the shower or during exercise, and wear after applying perfume or hair spray. Protect your piece from rain and humidity. When not wearing, be sure to store inside a jewelry box or in a soft jewelry pouch. Wear often, love always.</p>
        </div>
        <Footer></Footer>
        </>
    );
};

export default CustomerService;